(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ── Keyboard arrow navigation: desktop + mobile menus ──────────────────────
  (function () {
    'use strict';

    // ── Desktop helpers ────────────────────────────────────────────────────────

    function getTopItems(nav) {
      var topUl = nav.querySelector('ul.list-menu--inline');
      if (!topUl) return [];
      return Array.from(topUl.children).reduce(function (acc, li) {
        var item = li.querySelector(':scope > a') ||
                   li.querySelector(':scope > header-menu > details > summary');
        if (item) acc.push(item);
        return acc;
      }, []);
    }

    function getSubmenuItems(detailsEl) {
      var ul = detailsEl.querySelector(':scope > ul');
      if (!ul) return [];
      return Array.from(ul.children).reduce(function (acc, li) {
        var item = li.querySelector(':scope > a') ||
                   li.querySelector(':scope > details > summary');
        if (item) acc.push(item);
        return acc;
      }, []);
    }

    // Returns the <details> that *contains* target as an item (not the one it opens as summary)
    function findContainingDetails(target, nav) {
      var start = target.tagName === 'SUMMARY'
        ? target.parentElement.parentElement
        : target.parentElement;
      var el = start;
      while (el && el !== nav && nav.contains(el)) {
        if (el.tagName === 'DETAILS') return el;
        el = el.parentElement;
      }
      return null;
    }

    function handleDesktopKeydown(e) {
      var key = e.key;
      if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Escape','Home','End'].indexOf(key) === -1) return;

      var target = e.target;
      var nav    = e.currentTarget;

      var topItems = getTopItems(nav);
      var topIdx   = topItems.indexOf(target);
      var isTop    = topIdx !== -1;

      var containingDetails = findContainingDetails(target, nav);
      var submenuItems      = containingDetails ? getSubmenuItems(containingDetails) : [];
      var subIdx            = submenuItems.indexOf(target);

      switch (key) {
        case 'ArrowRight':
          e.preventDefault();
          if (isTop) {
            topItems[(topIdx + 1) % topItems.length].focus();
          } else if (target.tagName === 'SUMMARY') {
            var det = target.parentElement;
            det.open = true;
            var first = getSubmenuItems(det)[0];
            if (first) first.focus();
          }
          break;

        case 'ArrowLeft':
          e.preventDefault();
          if (isTop) {
            topItems[(topIdx - 1 + topItems.length) % topItems.length].focus();
          } else if (containingDetails) {
            containingDetails.open = false;
            var s = containingDetails.querySelector(':scope > summary');
            if (s) s.focus();
          }
          break;

        case 'ArrowDown':
          e.preventDefault();
          if (isTop) {
            if (target.tagName === 'SUMMARY') {
              var det = target.parentElement;
              det.open = true;
              var first = getSubmenuItems(det)[0];
              if (first) first.focus();
            } else {
              topItems[(topIdx + 1) % topItems.length].focus();
            }
          } else if (subIdx !== -1 && subIdx < submenuItems.length - 1) {
            submenuItems[subIdx + 1].focus();
          }
          break;

        case 'ArrowUp':
          e.preventDefault();
          if (isTop) {
            topItems[(topIdx - 1 + topItems.length) % topItems.length].focus();
          } else if (subIdx > 0) {
            submenuItems[subIdx - 1].focus();
          } else if (subIdx === 0 && containingDetails) {
            containingDetails.open = false;
            var s = containingDetails.querySelector(':scope > summary');
            if (s) s.focus();
          }
          break;

        case 'Escape':
          e.preventDefault();
          if (containingDetails) {
            containingDetails.open = false;
            var s = containingDetails.querySelector(':scope > summary');
            if (s) s.focus();
          } else if (target.tagName === 'SUMMARY' && target.parentElement.open) {
            target.parentElement.open = false;
            target.focus();
          }
          break;

        case 'Home':
          if (!isTop && submenuItems.length) { e.preventDefault(); submenuItems[0].focus(); }
          break;

        case 'End':
          if (!isTop && submenuItems.length) { e.preventDefault(); submenuItems[submenuItems.length - 1].focus(); }
          break;
      }
    }

    // ── Mobile helpers ─────────────────────────────────────────────────────────

    function handleMobileKeydown(e) {
      var key = e.key;
      if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Escape','Home','End'].indexOf(key) === -1) return;

      var target        = e.target;
      var mobileMenuEl  = e.currentTarget;
      var activeSubmenu = mobileMenuEl.querySelector('.dtcMobileMenu__submenu.active');

      if (activeSubmenu) {
        var subItems = Array.from(activeSubmenu.querySelectorAll('.dtcMobileMenu__submenuItem a'));
        var subIdx   = subItems.indexOf(target);

        switch (key) {
          case 'ArrowDown':
            e.preventDefault();
            if (subIdx !== -1 && subIdx < subItems.length - 1) subItems[subIdx + 1].focus();
            else if (subIdx === -1 && subItems.length) subItems[0].focus();
            break;

          case 'ArrowUp':
            e.preventDefault();
            if (subIdx > 0) {
              subItems[subIdx - 1].focus();
            } else if (subIdx === 0) {
              closeSubmenu();
              var parentLi = activeSubmenu.previousElementSibling;
              if (parentLi) { var pl = parentLi.querySelector('a'); if (pl) pl.focus(); }
            }
            break;

          case 'ArrowLeft':
          case 'Escape':
            e.preventDefault();
            var parentLiEsc = activeSubmenu.previousElementSibling;
            closeSubmenu();
            if (parentLiEsc) { var pl = parentLiEsc.querySelector('a'); if (pl) pl.focus(); }
            break;

          case 'Home':
            e.preventDefault();
            if (subItems.length) subItems[0].focus();
            break;

          case 'End':
            e.preventDefault();
            if (subItems.length) subItems[subItems.length - 1].focus();
            break;
        }
      } else {
        var mainItems = Array.from(
          mobileMenuEl.querySelectorAll(
            '.dtcMobileMenu__MenuItems > .dtcMobileMenu__item > a, ' +
            '.dtcMobileMenu__MenuItems > .dtcMobileMenu__item > button'
          )
        );
        var mainIdx = mainItems.indexOf(target);

        switch (key) {
          case 'ArrowDown':
            e.preventDefault();
            if (mainIdx !== -1 && mainIdx < mainItems.length - 1) mainItems[mainIdx + 1].focus();
            else if (mainIdx === -1 && mainItems.length) mainItems[0].focus();
            break;

          case 'ArrowUp':
            e.preventDefault();
            if (mainIdx > 0) mainItems[mainIdx - 1].focus();
            break;

          case 'ArrowRight':
            e.preventDefault();
            if (mainIdx !== -1) {
              var li = mainItems[mainIdx].parentElement;
              var sibling = li && li.nextElementSibling;
              if (sibling && sibling.classList.contains('dtcMobileMenu__submenu')) {
                openSubmenu(li);
                var firstSub = sibling.querySelector('.dtcMobileMenu__submenuItem a');
                if (firstSub) firstSub.focus();
              }
            }
            break;

          case 'Home':
            e.preventDefault();
            if (mainItems.length) mainItems[0].focus();
            break;

          case 'End':
            e.preventDefault();
            if (mainItems.length) mainItems[mainItems.length - 1].focus();
            break;
        }
      }
    }

    // ── Bootstrap ──────────────────────────────────────────────────────────────

    function initKeyboardNav() {
      document.querySelectorAll('nav.header__inline-menu').forEach(function (nav) {
        nav.addEventListener('keydown', handleDesktopKeydown);
      });
      var mobileMenuEl = document.querySelector('.dtcMobileMenu');
      if (mobileMenuEl) mobileMenuEl.addEventListener('keydown', handleMobileKeydown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initKeyboardNav);
    } else {
      initKeyboardNav();
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-peachy-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section');
      if (!this.header) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
